export default function(http) {
  return {
      queryByPage(data){
        return http.json({
          url: `/merchants/Activity/query`,
          data
        });
      },
      getInfo(data) {
          return http.json({
              url: `/merchants/Activity/get?id=${data.id}`
          })
      },
      save(data) {
          return http.json({
              url: `/merchants/Activity/save`,
              data
          })
      },
      remove(data) {
          return http.json({
              url: `/merchants/Activity/delete?id=${data[0].id}`,
              data
          })
      },




  };
}



// WEBPACK FOOTER //
// ./src/configure/http/api/mer_activity.js